import { useEffect, useRef } from "react";
import clsx from "clsx";
import "./project-related-tabs.scss";

interface IProjectRelatedTabs {
  tabs: string[];
  activeTab: string;
  setActiveTab: (tab: string) => void;
  tabsTranslate?: string[];
  /** Показывать оранжевую точку на вкладке (по индексу) */
  tabsWithDot?: boolean[];
}

export const ProjectRelatedTabs = ({
  tabs,
  activeTab,
  tabsTranslate,
  setActiveTab,
  tabsWithDot,
}: IProjectRelatedTabs) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const highlightRef = useRef<HTMLDivElement>(null);

  function getButtonWidth() {
    if (containerRef.current && highlightRef.current) {
      const activeIndex = tabs.indexOf(activeTab);
      const buttons = containerRef.current.querySelectorAll<HTMLButtonElement>(
        ".related-tab-button",
      );

      if (buttons[activeIndex]) {
        const button = buttons[activeIndex];
        const buttonOffsetWidth = button.offsetWidth;
        highlightRef.current.style.setProperty(
          "--related-highlight-width",
          `${buttonOffsetWidth}px`,
        );
        highlightRef.current.style.setProperty(
          "--related-highlight-transform",
          `translateX(${button.offsetLeft}px)`,
        );
      }
    }
  }

  useEffect(() => {
    getButtonWidth();
  }, [activeTab, tabs]);

  return (
    <div className="project-related-tabs-root">
      <div className="related-tabs-wrapper" ref={containerRef}>
        <div ref={highlightRef} className="related-highlight" />
        <div className="related-tabs">
          {tabs.map((tab, index) => (
            <button
              key={tab}
              type="button"
              className={clsx("related-tab-button", activeTab === tab && "active")}
              onClick={() => setActiveTab(tab)}
            >
              <span className="related-tab-button__label">
                {tabsTranslate ? tabsTranslate[index] : tab}
              </span>
              {tabsWithDot?.[index] && (
                <span className="related-tab-button__dot" aria-hidden />
              )}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
